export default function componentStyleOverrides(theme: any) {
  const borderRadius = '8px !important'
  const buttonBorderRadius = '12px !important'

  return {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Inter-Regular !important'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: buttonBorderRadius,
          minHeight: '42px',
          gap: '8px',
          fontWeight: 600,
          fontFamily: 'Inter-Regular !important',
          '& .MuiButton-startIcon': {
            marginRight: 0,
            marginLeft: 0
          },
          '& .MuiButton-endIcon': {
            marginLeft: '8px',
            marginRight: 0
          },
          '&.Mui-disabled': {
            backgroundColor: theme.colors.neutral100,
            color: theme.colors.neutral500,
            pointerEvents: 'none'
          }
        },
      }
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          padding: '0px'
        },
        rounded: {
          borderRadius: borderRadius
        }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          color: theme.colors?.textDark,
          padding: '24px',
          borderRadius: borderRadius
        },
        title: {
          fontSize: '1.125rem'
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
          color: theme.colors?.primaryMain,
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline !important'
          }
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '16px',
          '@media (max-width: 767px)': {
            padding: '16px'
          },
          borderRadius: borderRadius
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: '24px'
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          color: theme.colors.dark400,
          paddingTop: '10px',
          paddingBottom: '10px',
          '&.Mui-selected': {
            color: theme.colors.primaryMain,
            borderRadius: '12px !important',
            backgroundColor: theme.colors.violet50,
            '&:hover': {
              borderRadius: '12px !important',
              backgroundColor: theme.colors.violet50
            },
            '& .MuiListItemIcon-root': {
              color: theme.colors.primaryMain
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              left: '0px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '4px',
              height: '24px',
              borderRadius: '100px',
              backgroundColor: theme.colors.primaryMain
            }
          },

          '&:hover': {
            backgroundColor: theme.colors.violet50,
            borderRadius: '12px !important',

            color: theme.colors.primaryMain,
            '& .MuiListItemIcon-root': {
              color: theme.colors.primaryMain
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              left: '0px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '4px',
              height: '24px',
              borderRadius: '100px',
              backgroundColor: theme.colors.primaryMain
            }
          }
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: theme.darkTextPrimary,
          minWidth: '36px'
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: theme.textDark
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: theme.colors.neutral900,
          fontSize: '14px',
          '&::placeholder': {
            color: theme.colors.neutral500,
            fontSize: '14px',
            lineHeight: '18px'
          }
        }
      }
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: '#ffffff',
          filter: 'drop-shadow(0px 2px 7px rgba(0,0,0,0.03))',
          borderRadius: borderRadius,
          transition: 'all 0.2s ease',

          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors?.neutral200
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors?.neutral300
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors?.primaryMain
          },
          '&.Mui-disabled': {
            background: theme.colors.neutral100,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.colors.neutral200
            }
          },
          '&.MuiInputBase-multiline': {
            padding: 0
          },

          '&.MuiInputBase-adornedStart, &.MuiInputBase-adornedEnd': {
            background: '#ffffff'
          }
        },

        input: {
          fontWeight: 500,
          padding: '14px 20px',
          borderRadius: borderRadius,
          background: 'transparent'
        },

        inputAdornedStart: {
          paddingLeft: '20px'
        },
        inputAdornedEnd: {
          paddingRight: '20px'
        },
        notchedOutline: {
          borderRadius: borderRadius
        }
      }
    },

    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: theme.colors.neutral600,
          background: 'transparent',
          display: 'flex',
          alignItems: 'center',

          '& .MuiIconButton-root': {
            color: theme.colors.neutral600,
            padding: '4px',
            transition: 'all 0.2s ease',
            '&:hover': {
              color: theme.colors.primaryMain
            },
            '&:active': {
              transform: 'scale(0.95)'
            },
            '& svg': {
              fontSize: '20px'
            }
          },

          '&.MuiInputAdornment-positionStart': {
            marginLeft: '16px'
          },
          '&.MuiInputAdornment-positionEnd': {
            marginRight: '16px'
          }
        }
      }
    },

    MuiSlider: {
      styleOverrides: {
        root: {
          color: theme.colors?.menuBackgroundPrimary
        },
        thumb: {
          '&:before': {
            background: 'white !important',
            border: '2px solid !important'
          }
        },
        mark: {
          backgroundColor: theme.paper,
          width: '4px'
        },
        valueLabel: {
          color: theme?.colors?.primaryLight
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.divider,
          opacity: 1
        }
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        lineHorizontal: {
          border: '2px solid !important',
          borderColor: theme.colors?.menuBackgroundPrimary + ' !important',
          background: theme.palette?.dark[50] + ' !important'
        }
      }
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          color: theme.colors?.primaryDark,
          background: theme.colors?.primary200
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none'
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #e0e0e0'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-deletable .MuiChip-deleteIcon': {
            color: 'inherit'
          }
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: theme.paper,
          background: theme.colors?.grey700
        }
      }
    },
    MuiButtonBase: {
      borderRadius: '0 !important',
      styleOverrides: {
        root: {
          '@media (max-width: 767px)': {
            padding: '5px 10px !important'
          }
        }
      }
    },
    MuiStepLabel: {
      styleOverrides: {
        '&.Mui-disabled': {
          background: 'red !important'
        }
      }
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        li: {
          fontSize: '18px'
        },
        separator: {
          fontSize: '18px',
          margin: '0px 16px'
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          marginTop: '16px',
          marginBottom: '4px',
          color: '#344054',
          fontSize: '14px',
          fontWeight: 'bold'
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          maxHeight: 'calc(100% - 30px)',
          maxWidth: '600px',
          margin: '0',
          width: 'calc(100% - 30px)'
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1rem !important'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          marginTop: '4px !important'
        }
      }
    }
  }
}
